import {Button, Modal, Select} from "antd";
import {useState} from "react";

export default function SampleProjectModal({open, onOk, onCancel}) {
    const [modelA, setModelA] = useState(null)
    const [modelB, setModelB] = useState(null)
    const [spinner, setSpinner] = useState(false)

    const onChange = async (type, val) => {
        if(type === 'model_a') {
            setModelA(val)
        } else if(type === 'model_b') {
            setModelB(val)
        }
    }

    const complete = async () => {
        let prjA = null
        let prjB = null

        setSpinner(true)
        if(modelA) {
            const res = await fetch(`/sample/${modelA}.json`)
            if(res.ok) {
                prjA = await res.json()
            }
        }

        if(modelB) {
            const res = await fetch(`/sample/${modelB}.json`)
            if(res.ok) {
                prjB = await res.json()
            }
        }

        setSpinner(false)
        setModelA(null)
        setModelB(null)
        onOk(prjA, prjB)
    }

    return (
        <Modal title="Sample HEC-RAS Models" open={open} footer={(<div />)} onCancel={onCancel}>
            <Select
                onClick={(e) => {e.preventDefault(); e.stopPropagation()}}
                allowClear={true}
                value={modelA}
                onClear={() => onChange('model_a', null)}
                placeholder={'Model A - Select Sample HEC-RAS Model'}
                onChange={(val) => onChange('model_a', val)}
                style={{width: '100%'}}
            >
                <Select.Option value={'model_1'}>
                    Sample Model - Mill Creek Effective
                </Select.Option>
                <Select.Option value={'model_2'}>
                    Sample Model - Mill Creek LOMR
                </Select.Option>
            </Select>
            <Select
                onClick={(e) => {e.preventDefault(); e.stopPropagation()}}
                allowClear={true}
                value={modelB}
                onClear={() => onChange('model_b', null)}
                placeholder={'Model B - Select Sample HEC-RAS Model'}
                onChange={(val) => onChange('model_b', val)}
                style={{width: '100%', marginTop: 8}}
            >
                <Select.Option value={'model_1'}>
                    Sample Model - Mill Creek Effective
                </Select.Option>
                <Select.Option value={'model_2'}>
                    Sample Model - Mill Creek LOMR
                </Select.Option>
            </Select>
            <br/>
            <br/>
            <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                <Button type={'primary'} onClick={complete} loading={spinner}>
                    Ok
                </Button>
                <Button onClick={onCancel} loading={spinner}>
                    Cancel
                </Button>
            </div>
        </Modal>
    )
}